import { render, staticRenderFns } from "./FormalAgreements.vue?vue&type=template&id=7bb0bda8&scoped=true"
import script from "./FormalAgreements.vue?vue&type=script&lang=js"
export * from "./FormalAgreements.vue?vue&type=script&lang=js"
import style0 from "./FormalAgreements.vue?vue&type=style&index=0&id=7bb0bda8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb0bda8",
  null
  
)

export default component.exports